import { Form, Input } from 'antd';

const CustomTextInput = ({ form, size = 'default', label, head, name, rules, value, count, disabled, placeholder = 'Write here', style }) => {
	// console.log(form?.getFieldValue(name));

	return (
		<Form.Item label={label} name={name} rules={rules} style={style}>
			{/* {disabled ? (
				<CustomInputLabel head={head} label={form?.getFieldValue(name) ?? (value ? value : '')} sx={{ ...style }} />
			) : ( */}
			<Input name={name} count={count} placeholder={placeholder} size={size} disabled={disabled} />
			{/* )} */}
		</Form.Item>
	);
};

export default CustomTextInput;
